export const BOARD_SUB_FILTER_API_PATH = '/rest/greenhopper/1.0/subqueries';
